import { render } from "./AttendanceDashboard.vue?vue&type=template&id=61d50e27&scoped=true"
import script from "./AttendanceDashboard.vue?vue&type=script&lang=js"
export * from "./AttendanceDashboard.vue?vue&type=script&lang=js"

import "./AttendanceDashboard.vue?vue&type=style&index=0&id=61d50e27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d50e27"]])

export default __exports__